import { toast } from "react-toastify";
import requestUtil from "../../helpers/requestUtil";
import {
  setDepartmentList,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
} from "./slice";
import { fetchDepsUnits } from "../Login/action";

// Get Department
export function getDepartmentLists(baseUrl) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/Departments/get-department-details`,
        "GET"
      );
      dispatch(setDepartmentList(response?.departmentList));
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Create Department
export function createDepartment(baseUrl, params) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/Departments/create-department`,
        "POST",
        { ...params }
      );
      toast.success("Department name created  successfully!");
      if(params?.isActive){
        dispatch(fetchDepsUnits({baseUrl}))
      }
      return response;
    } catch (error) {
      toast.error("Department name already exists!");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Update Department
export function updateDepartment(baseUrl, params) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/Departments/update-department`,
        "POST",
        { ...params }
      );
      toast.success("Department name updated successfully!");
      dispatch(fetchDepsUnits({baseUrl}))
      return response;
    } catch (error) {
      toast.error(error.message);
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// delete Department
export function deleteDepartment(baseUrl, CandidateDepartmentId) {
  return async (dispatch) => {
    try {
      dispatch(setLoadingFlagIncrement());
      const response = await requestUtil(
        `${baseUrl}/Departments/delete-department?CandidateDepartmentId=${CandidateDepartmentId}`,
        "DELETE"
      );
      toast.success("Department name deleted successfully!");
      dispatch(fetchDepsUnits({baseUrl}))
      return response;
    } catch (error) {
      toast.error("This department can't be deleted, because it is mapped!.");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
